import { createFileRoute, Link } from "@tanstack/react-router";
import { ArrowRight, HelpCircle } from "lucide-react";
import { Breadcrumbs } from "@/components/Breadcrumbs";
import { breadcrumbJsonLd } from "@/lib/seo-jsonld";
import { FREE_CTA, PREMIUM_CTA } from "@/lib/cta";

const GROUPS = [
  {
    "title": "Grunder & serveringstillstånd",
    "items": [
      {
        "slug": "vad-ar-serveringstillstand",
        "q": "Vad är ett serveringstillstånd?"
      },
      {
        "slug": "vem-behover-serveringstillstand",
        "q": "Vem behöver söka serveringstillstånd?"
      },
      {
        "slug": "vilka-typer-av-serveringstillstand-finns",
        "q": "Vilka typer av serveringstillstånd finns?"
      },
      {
        "slug": "vad-kostar-ansokan",
        "q": "Vad kostar en ansökan om serveringstillstånd?"
      },
      {
        "slug": "hur-lang-handlaggningstid",
        "q": "Hur lång är handläggningstiden för serveringstillstånd?"
      },
      {
        "slug": "vilka-dokument-kravs",
        "q": "Vilka dokument krävs i ansökan om serveringstillstånd?"
      },
      {
        "slug": "behover-jag-eget-kok-2026",
        "q": "Behöver jag eget kök 2026 för att få serveringstillstånd?"
      },
      {
        "slug": "far-jag-servera-utan-mat",
        "q": "Får jag servera alkohol utan att servera mat 2026?"
      },
      {
        "slug": "vad-ar-stadigvarande-tillstand",
        "q": "Vad är ett stadigvarande serveringstillstånd?"
      },
      {
        "slug": "vad-ar-tillfalligt-tillstand",
        "q": "Vad är ett tillfälligt serveringstillstånd?"
      },
      {
        "slug": "skillnad-stadigvarande-tillfalligt",
        "q": "Vad är skillnaden mellan stadigvarande och tillfälligt tillstånd?"
      },
      {
        "slug": "cateringtillstand-vad-innebar-det",
        "q": "Vad innebär ett cateringtillstånd?"
      },
      {
        "slug": "kan-jag-anvanda-pausservering",
        "q": "Vad är pausservering och vem kan få det?"
      },
      {
        "slug": "vad-ar-gemensam-serveringsyta",
        "q": "Vad är en gemensam serveringsyta?"
      },
      {
        "slug": "far-jag-ha-uteservering",
        "q": "Får jag ha uteservering med serveringstillstånd?"
      },
      {
        "slug": "hur-soker-jag-uteservering",
        "q": "Hur söker jag tillstånd för uteservering?"
      },
      {
        "slug": "vad-ar-provsmakningstillstand",
        "q": "Vad är ett provsmakningstillstånd?"
      },
      {
        "slug": "kan-jag-overlata-mitt-tillstand",
        "q": "Kan jag överlåta mitt serveringstillstånd till en ny ägare?"
      },
      {
        "slug": "hur-anmaler-jag-andringar",
        "q": "Hur anmäler jag ändringar i min verksamhet?"
      },
      {
        "slug": "nar-behover-jag-anmala-ny-agare",
        "q": "När måste jag anmäla ny ägare eller styrelseledamot?"
      },
      {
        "slug": "far-jag-saljs-pa-bordet",
        "q": "Får gäster själva fylla på drinkar vid bordet?"
      },
      {
        "slug": "vad-betyder-personlig-lamplighet",
        "q": "Vad betyder personlig lämplighet enligt alkohollagen?"
      },
      {
        "slug": "vad-ar-pbi-kretsen",
        "q": "Vad är PBI-kretsen?"
      },
      {
        "slug": "kan-mitt-tillstand-aterkallas",
        "q": "Kan mitt serveringstillstånd återkallas?"
      },
      {
        "slug": "vad-skiljer-erinran-fran-varning",
        "q": "Vad är skillnaden mellan erinran och varning?"
      }
    ]
  },
  {
    "title": "Kunskapsprovet",
    "items": [
      {
        "slug": "vad-ar-kunskapsprovet",
        "q": "Vad är kunskapsprovet i alkohollagen?"
      },
      {
        "slug": "hur-manga-fragor-har-provet",
        "q": "Hur många frågor har kunskapsprovet?"
      },
      {
        "slug": "hur-manga-ratt-kravs",
        "q": "Hur många rätt krävs på kunskapsprovet?"
      },
      {
        "slug": "hur-lang-tid-tar-provet",
        "q": "Hur lång tid har jag på mig på kunskapsprovet?"
      },
      {
        "slug": "far-jag-anvanda-lagboken",
        "q": "Får jag använda lagboken på kunskapsprovet?"
      },
      {
        "slug": "kostar-kunskapsprovet-extra",
        "q": "Kostar kunskapsprovet extra utöver ansökan?"
      },
      {
        "slug": "hur-manga-forsok-har-jag",
        "q": "Hur många försök har jag på kunskapsprovet?"
      },
      {
        "slug": "vad-hander-om-jag-blir-underkand",
        "q": "Vad händer om jag blir underkänd på kunskapsprovet?"
      },
      {
        "slug": "var-bokar-jag-provet",
        "q": "Var bokar jag kunskapsprovet?"
      },
      {
        "slug": "far-jag-gora-provet-pa-engelska",
        "q": "Får jag göra kunskapsprovet på engelska?"
      },
      {
        "slug": "far-jag-tolk-pa-provet",
        "q": "Får jag använda tolk på kunskapsprovet?"
      },
      {
        "slug": "behover-alla-i-ledningen-gora-provet",
        "q": "Behöver alla i ledningen göra kunskapsprovet?"
      },
      {
        "slug": "vilka-delar-ingar-i-provet",
        "q": "Vilka delar ingår i kunskapsprovet?"
      },
      {
        "slug": "vad-ar-skillnad-stadigvarande-prov-tillfalligt",
        "q": "Vad är skillnaden mellan provet för stadigvarande och tillfälligt tillstånd?"
      },
      {
        "slug": "galler-provet-i-alla-kommuner",
        "q": "Gäller godkänt kunskapsprov i alla kommuner?"
      },
      {
        "slug": "hur-lange-galler-godkant-prov",
        "q": "Hur länge gäller ett godkänt kunskapsprov?"
      },
      {
        "slug": "behover-jag-gora-om-provet-vid-utokning",
        "q": "Behöver jag göra om provet om jag utökar tillståndet?"
      },
      {
        "slug": "hur-bra-ar-folkhalsomyndighetens-databas",
        "q": "Hur ser kunskapsprovets frågedatabas ut?"
      },
      {
        "slug": "far-jag-rast-under-provet",
        "q": "Får jag ta rast under kunskapsprovet?"
      },
      {
        "slug": "hur-rattas-provet",
        "q": "Hur rättas kunskapsprovet?"
      },
      {
        "slug": "vilken-paragraf-styr-kunskapsprovet",
        "q": "Vilken paragraf styr kunskapsprovet?"
      },
      {
        "slug": "far-funktionshindrade-extra-tid",
        "q": "Får funktionshindrade extra tid på kunskapsprovet?"
      },
      {
        "slug": "ar-provet-svart",
        "q": "Är kunskapsprovet svårt?"
      },
      {
        "slug": "hur-pluggar-jag-effektivt",
        "q": "Hur pluggar jag effektivt inför kunskapsprovet?"
      },
      {
        "slug": "kan-jag-trana-gratis",
        "q": "Kan jag träna på kunskapsprovet gratis?"
      }
    ]
  },
  {
    "title": "PBI & lämplighetsprövning",
    "items": [
      {
        "slug": "vad-betyder-pbi",
        "q": "Vad betyder PBI?"
      },
      {
        "slug": "vilka-rakas-till-pbi-kretsen",
        "q": "Vilka räknas till PBI-kretsen?"
      },
      {
        "slug": "vad-galler-for-finansierare-av-verksamhet",
        "q": "Räknas finansiärer in i PBI-kretsen?"
      },
      {
        "slug": "nar-bedoms-ekonomisk-lamplighet",
        "q": "Hur bedöms ekonomisk lämplighet?"
      },
      {
        "slug": "vad-ar-vandel",
        "q": "Vad menas med 'god vandel' i alkohollagen?"
      },
      {
        "slug": "far-jag-tillstand-med-skatteskuld",
        "q": "Kan jag få serveringstillstånd om jag har skatteskuld?"
      },
      {
        "slug": "far-jag-tillstand-med-tidigare-domar",
        "q": "Får jag serveringstillstånd om jag har tidigare domar?"
      },
      {
        "slug": "hur-lang-tid-tillbaka-tittar-kommunen",
        "q": "Hur långt tillbaka tittar kommunen vid lämplighetsprövning?"
      },
      {
        "slug": "vad-ar-bulvanforhallanden",
        "q": "Vad är ett bulvanförhållande?"
      },
      {
        "slug": "vem-galler-som-styrelseledamot-vid-pbi-prov",
        "q": "Räknas alla styrelseledamöter i PBI-kretsen?"
      }
    ]
  },
  {
    "title": "Drift & dagliga regler",
    "items": [
      {
        "slug": "vilken-aldersgrans-galler-for-servering",
        "q": "Vilken åldersgräns gäller för servering av alkohol?"
      },
      {
        "slug": "far-jag-servera-till-onykter-gast",
        "q": "Får jag servera alkohol till en onykter gäst?"
      },
      {
        "slug": "hur-langt-far-jag-ha-oppet",
        "q": "Hur länge får jag ha öppet med serveringstillstånd?"
      },
      {
        "slug": "ar-25-arsgrans-vid-tveksamhet-laglig",
        "q": "Får jag ha 25-årsgräns på restaurangen?"
      },
      {
        "slug": "far-jag-tillata-egen-medhavd-alkohol",
        "q": "Får gäster ta med egen alkohol till restaurangen?"
      },
      {
        "slug": "far-jag-salja-takeaway-vin-med-mat",
        "q": "Får jag sälja vin för avhämtning tillsammans med mat?"
      },
      {
        "slug": "vad-galler-for-happy-hour",
        "q": "Får jag erbjuda happy hour?"
      },
      {
        "slug": "far-jag-marknadsfora-alkohol-i-sociala-medier",
        "q": "Får jag marknadsföra alkohol på sociala medier?"
      },
      {
        "slug": "far-jag-erbjuda-fri-alkohol-som-kampanj",
        "q": "Får jag bjuda gäster på alkohol som marknadsföring?"
      },
      {
        "slug": "vad-galler-for-prissattning",
        "q": "Får jag sänka alkoholpriserna hur mycket jag vill?"
      },
      {
        "slug": "far-jag-anvanda-personalrabatt",
        "q": "Får personalen få alkohol gratis eller till rabatt?"
      },
      {
        "slug": "vad-ar-egenkontrollprogram",
        "q": "Vad är ett egenkontrollprogram?"
      },
      {
        "slug": "vilka-anteckningar-maste-jag-fora",
        "q": "Vilka anteckningar måste jag föra i verksamheten?"
      },
      {
        "slug": "vad-galler-vid-personalfest",
        "q": "Får jag servera alkohol på personalfest utan extra tillstånd?"
      },
      {
        "slug": "far-personalen-dricka-pa-jobbet",
        "q": "Får personalen dricka alkohol under arbetspasset?"
      }
    ]
  },
  {
    "title": "Ordning & tillsyn",
    "items": [
      {
        "slug": "vad-ar-ordningsvakter-och-nar-kravs-de",
        "q": "När krävs ordningsvakter på en restaurang?"
      },
      {
        "slug": "vad-galler-vid-tillsynsbesok",
        "q": "Vad gäller vid ett tillsynsbesök?"
      },
      {
        "slug": "vad-hander-om-jag-far-en-anmarkning",
        "q": "Vad händer om jag får en anmärkning vid tillsyn?"
      },
      {
        "slug": "hur-overklagar-jag-ett-beslut",
        "q": "Hur överklagar jag ett beslut om serveringstillstånd?"
      },
      {
        "slug": "nar-leder-sanktionsavgift",
        "q": "Vad är en sanktionsavgift och när tas den ut?"
      },
      {
        "slug": "vad-galler-vid-misstankt-narkotikahandel",
        "q": "Vad gäller om jag misstänker narkotikahandel i lokalen?"
      },
      {
        "slug": "vad-galler-vid-vald-pa-stallet",
        "q": "Vad gäller om det inträffar våld på serveringsstället?"
      },
      {
        "slug": "ar-id-kontroll-obligatorisk",
        "q": "Är ID-kontroll obligatorisk vid alkoholservering?"
      },
      {
        "slug": "far-jag-neka-en-gast-tilltrade",
        "q": "Får jag neka en gäst tillträde till restaurangen?"
      },
      {
        "slug": "vad-galler-for-personal-utan-anstallningsavtal",
        "q": "Får jag använda personal utan anställningsavtal?"
      }
    ]
  },
  {
    "title": "Evenemang & tillfälligt tillstånd",
    "items": [
      {
        "slug": "vad-galler-for-festival-och-utomhus",
        "q": "Vad gäller för alkoholservering på festival eller utomhus?"
      },
      {
        "slug": "behover-mojligheten-kommunens-godkannande-i-forvag",
        "q": "Måste evenemangsplats godkännas i förväg?"
      },
      {
        "slug": "hur-lange-far-tillfalligt-tillstand-vara",
        "q": "Hur länge kan ett tillfälligt serveringstillstånd gälla?"
      },
      {
        "slug": "far-jag-foreningens-arsfest-utan-tillstand",
        "q": "Behöver föreningen tillstånd för årsfest med vin?"
      },
      {
        "slug": "far-jag-ha-tillstand-utan-fysisk-lokal",
        "q": "Kan jag få serveringstillstånd utan fast lokal?"
      },
      {
        "slug": "food-truck-vad-galler",
        "q": "Vad gäller för food truck och alkoholservering?"
      },
      {
        "slug": "hur-mycket-kostar-tillfalligt-tillstand",
        "q": "Vad kostar ett tillfälligt serveringstillstånd?"
      }
    ]
  },
  {
    "title": "Gårdsförsäljning & nya regler 2026",
    "items": [
      {
        "slug": "vad-ar-gardsforsaljning-2026",
        "q": "Vad är gårdsförsäljning enligt det nya regelverket 2026?"
      },
      {
        "slug": "vem-far-salja-pa-gardsforsaljning",
        "q": "Vem får sälja alkohol via gårdsförsäljning?"
      },
      {
        "slug": "hur-mycket-far-jag-salja-per-besokare",
        "q": "Hur mycket alkohol får jag sälja per besökare vid gårdsförsäljning?"
      },
      {
        "slug": "behover-jag-egen-tillverkning",
        "q": "Måste jag tillverka själv för att få gårdsförsäljning?"
      },
      {
        "slug": "far-vingard-salja-via-natet",
        "q": "Får en vingård sälja vin via nätet under gårdsförsäljningsreglerna?"
      },
      {
        "slug": "vilka-volymregler-galler-for-mikrobryggeri",
        "q": "Vilka volymregler gäller för mikrobryggeri vid gårdsförsäljning?"
      },
      {
        "slug": "nar-trader-gardsforsaljning-i-kraft",
        "q": "När träder gårdsförsäljningen i kraft?"
      },
      {
        "slug": "vad-ar-skillnaden-mot-systembolaget",
        "q": "Vad skiljer gårdsförsäljning från Systembolaget?"
      }
    ]
  }
] as const;

export const Route = createFileRoute("/fraga/")({
  component: FragaIndex,
  validateSearch: (search: Record<string, unknown>) => ({
    q: typeof search.q === "string" ? search.q : undefined,
  }),
  head: () => ({
    meta: [
      { title: "Frågor & svar om serveringstillstånd och kunskapsprovet" },
      { name: "description", content: "100 vanliga frågor om serveringstillstånd, kunskapsprovet i alkohollagen, PBI-kretsen, gårdsförsäljning 2026 och daglig drift – med officiella källor." },
      { property: "og:title", content: "Frågor & svar – Alkoholprovet" },
      { property: "og:description", content: "100 svar på vanliga frågor om alkohollagen, serveringstillstånd och kunskapsprovet." },
      { property: "og:url", content: "https://alkoholprovet.se/fraga" },
    ],
    links: [{ rel: "canonical", href: "https://alkoholprovet.se/fraga" }],
    scripts: [
      breadcrumbJsonLd([
        { label: "Hem", url: "https://alkoholprovet.se/" },
        { label: "Frågor & svar", url: "https://alkoholprovet.se/fraga" },
      ]),
    ],
  }),
});

function FragaIndex() {
  const { q } = Route.useSearch();
  const navigate = Route.useNavigate();
  const query = (q ?? "").trim().toLowerCase();
  const groups = query
    ? GROUPS.map((g) => ({ ...g, items: g.items.filter((it) => it.q.toLowerCase().includes(query)) })).filter(
        (g) => g.items.length > 0,
      )
    : GROUPS;
  const hits = groups.reduce((n, g) => n + g.items.length, 0);

  return (
    <article className="container-narrow py-12 sm:py-16">
      <Breadcrumbs items={[{ label: "Hem", to: "/" }, { label: "Frågor & svar" }]} />
      <div className="flex items-center gap-2 text-xs uppercase tracking-wide text-accent font-medium">
        <HelpCircle className="h-4 w-4" /> Kunskapsbank
      </div>
      <h1 className="mt-2 font-display text-4xl sm:text-5xl font-bold tracking-tight text-balance">
        Frågor & svar om alkohollagen
      </h1>
      <p className="mt-4 text-lg text-muted-foreground">
        100 korta, källcitatuppbackade svar på de vanligaste frågorna om serveringstillstånd, kunskapsprovet, gårdsförsäljning 2026 och daglig drift.
      </p>

      <form
        role="search"
        className="mt-8 flex flex-wrap gap-3"
        onSubmit={(e) => e.preventDefault()}
      >
        <label htmlFor="fraga-sok" className="sr-only">
          Sök bland frågor och svar
        </label>
        <input
          id="fraga-sok"
          type="search"
          value={q ?? ""}
          onChange={(e) => {
            const value = e.target.value;
            navigate({ search: { q: value || undefined }, replace: true });
          }}
          placeholder="Sök fråga, t.ex. åldersgräns eller catering"
          className="w-full sm:max-w-md rounded-xl border border-border bg-card px-4 py-3 text-sm"
        />
      </form>
      {query && (
        <p className="mt-3 text-sm text-muted-foreground" aria-live="polite">
          {hits} {hits === 1 ? "fråga" : "frågor"} matchar ”{q}”.
        </p>
      )}

      <div className="mt-10 space-y-10">
        {groups.map((g) => (
          <section key={g.title}>
            <h2 className="font-display text-2xl font-semibold">{g.title}</h2>
            <ul className="mt-4 grid gap-2 sm:grid-cols-2">
              {g.items.map((it) => (
                <li key={it.slug}>
                  <a href={`/fraga/${it.slug}`} className="inline-flex items-center gap-2 text-accent hover:underline text-sm"
                  >
                    <ArrowRight className="h-4 w-4 shrink-0" /> {it.q}
                  </a>
                </li>
              ))}
            </ul>
          </section>
        ))}
      </div>

      <div className="mt-12 rounded-2xl bg-surface-deep text-primary-foreground p-8 text-center">
        <h2 className="font-display text-2xl font-bold">Redo att börja öva?</h2>
        <p className="mt-2 text-primary-foreground/80">Börja gratis utan kort. Lås upp obegränsat med Premium.</p>
        <div className="mt-5 flex flex-wrap justify-center gap-3">
          <Link to={FREE_CTA.to} className="inline-flex items-center gap-2 rounded-xl bg-white text-primary px-6 py-3 text-sm font-medium hover:bg-white/90">
            {FREE_CTA.label} <ArrowRight className="h-4 w-4" />
          </Link>
          <Link to={PREMIUM_CTA.to} className="inline-flex items-center gap-2 rounded-xl border border-white/30 text-primary-foreground px-6 py-3 text-sm font-medium hover:bg-white/10">
            {PREMIUM_CTA.label} <ArrowRight className="h-4 w-4" />
          </Link>
        </div>
      </div>
    </article>
  );
}
